import React from 'react';
import { gtag_report_conversion, trackWhatsAppClick, CONVERSION_IDS } from '../utilities/trackingUtils';
import './HeroSection.css';

const HeroSection = () => {
  const handleCallNow = () => {
    gtag_report_conversion('tel:+917816088532', CONVERSION_IDS.PHONE_CLICK, 'Hero Call Now Button');
  };

  const handleWhatsApp = () => {
    trackWhatsAppClick('Hero WhatsApp Button');
    // Navigate to WhatsApp after tracking
    setTimeout(() => {
      window.open('https://wa.me/917816088532', '_blank');
    }, 100);
  };

  return (
    <section id="home" className="hero-section">
      <div className="hero-overlay"></div>
      <div className="container hero-content">
        <div className="headline-wrapper">
          <h1 className="main-headline">Looking for a Home Tutor?</h1>
          <div className="headline-accent"></div>
        </div>
        <div className="thought-cloud">
          <span className="cloud-text">Book a Free Demo</span>
        </div>
        
        {/* Primary CTA buttons (Call Now & WhatsApp) */}
        <div className="hero-buttons hero-buttons-primary">
          <a onClick={handleCallNow} href="tel:+917816088532" className="btn btn-call-now">
            <i className="fas fa-phone"></i> Call Now: +91 7816088532
          </a>
          <button onClick={handleWhatsApp} className="btn btn-whatsapp">
            <i className="fab fa-whatsapp"></i> WhatsApp: +91 7816088532
          </button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection; 